import { render, staticRenderFns } from "./discountConfigItem.vue?vue&type=template&id=7f024ada&scoped=true&"
import script from "./discountConfigItem.vue?vue&type=script&lang=js&"
export * from "./discountConfigItem.vue?vue&type=script&lang=js&"
import style0 from "./discountConfigItem.vue?vue&type=style&index=0&id=7f024ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f024ada",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
